import axios from "axios";
import { SagaIterator } from "redux-saga";
import { call, cancelled, put, takeLatest } from "redux-saga/effects";

import { callGet } from "../../http_client";

import {
  integrationErrorsChartFetchError,
  integrationErrorsChartFetchRequest,
  integrationErrorsChartFetchSuccess,
  integrationErrorsFetchError,
  integrationErrorsFetchRequest,
  integrationErrorsFetchSuccess,
  integrationErrorsSamplesFetchError,
  integrationErrorsSamplesFetchRequest,
  integrationErrorsSamplesFetchSuccess,
} from "./actions";
import { IntegrationErrorsActionTypes } from "./types";

export function* handleIntegrationErrorsFetch(action: ReturnType<typeof integrationErrorsFetchRequest>): SagaIterator {
  const source = axios.CancelToken.source();
  try {
    const { from, to, gateId, page, pageSize, resolution, ordering, errorsType } = action.payload;
    const response = yield call(
      callGet,
      "/errors/",
      {
        from,
        to,
        gateId,
        page,
        pageSize,
        resolution,
        ordering,
        errorsType,
      },
      source.token
    );
    yield put(integrationErrorsFetchSuccess(response.data));
  } catch (err) {
    yield put(integrationErrorsFetchError(err.message));
  } finally {
    if (yield cancelled()) {
      source.cancel();
    }
  }
}

export function* handleIntegrationErrorsSampleFetch(
  action: ReturnType<typeof integrationErrorsSamplesFetchRequest>
): SagaIterator {
  const source = axios.CancelToken.source();
  try {
    const { gateId } = action.payload;
    const response = yield call(callGet, "/errors/samples/", { gateId }, source.token);
    yield put(integrationErrorsSamplesFetchSuccess(response.data));
  } catch (err) {
    yield put(integrationErrorsSamplesFetchError(err.message));
  } finally {
    if (yield cancelled()) {
      source.cancel();
    }
  }
}

export function* handleIntegrationErrorsChartFetch(
  action: ReturnType<typeof integrationErrorsChartFetchRequest>
): SagaIterator {
  const source = axios.CancelToken.source();
  try {
    const { from, to, gateId, resolution } = action.payload;
    const response = yield call(callGet, "/errors/chart/", { from, to, gateId, resolution }, source.token);
    yield put(integrationErrorsChartFetchSuccess(response.data));
  } catch (err) {
    yield put(integrationErrorsChartFetchError(err.message));
  } finally {
    if (yield cancelled()) {
      source.cancel();
    }
  }
}

function* watchIntegrationErrorsSagas(): SagaIterator {
  yield takeLatest(IntegrationErrorsActionTypes.TABLE_FETCH_REQUEST, handleIntegrationErrorsFetch);
  yield takeLatest(IntegrationErrorsActionTypes.CHART_FETCH_REQUEST, handleIntegrationErrorsChartFetch);
  yield takeLatest(IntegrationErrorsActionTypes.SAMPLES_FETCH_REQUEST, handleIntegrationErrorsSampleFetch);
}

export default watchIntegrationErrorsSagas;
